<template>
  <datepicker
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    :month-change-on-scroll="false"
    format="yyyy-MM-dd"
    :clearable="true"
    :auto-apply="true"
    :time-picker="false"
    :week-start="weekStart"
    locale="ja"
    :hide-navigation="['time']"
    model-type="yyyy-MM-dd"
    :placeholder="placeholder"
    :max-date="maxDate"
  />
</template>

<script>
export default {
  name: 'SinglePicker',
  props: {
    placeholder: {
      default: ""
    },
    modelValue: {},
    maxDate: {
      default: null,
    },
    weekStart: {
      default: 0
    },
  }
}
</script>
